// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cbEM","field":"styles_field__3xKgu","fieldCol":"styles_fieldCol__Y12ZW","diffCol":"styles_diffCol__K7GwA","diff":"styles_diff__3ooxn"};